import { render, staticRenderFns } from "./cq-card.vue?vue&type=template&id=1c4b1c6e&scoped=true&"
import script from "./cq-card.vue?vue&type=script&lang=js&"
export * from "./cq-card.vue?vue&type=script&lang=js&"
import style0 from "./cq-card.vue?vue&type=style&index=0&id=1c4b1c6e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c4b1c6e",
  null
  
)

export default component.exports